import {framework} from '../etc/theme'
let {drawerWidth} = framework

let styles = theme =>({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
  },
  content: {
    width: `calc(100% - ${theme.spacing.unit * 2}px)`,
    display: 'flex',
    justifyContent: 'center',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    paddingTop: theme.spacing.unit * 3,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 'calc(100% - 56px)',
    marginTop: 56,
    [theme.breakpoints.up('sm')]: {
      content: {
        height: 'calc(100% - 64px)',
        marginTop: 64,
      },
    },
    padding: theme.spacing.unit
  },
  contentShift: {
    marginLeft: drawerWidth,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  actualContent:{

  },
  actualContentFocus:
  {
    zIndex: 500
  },
  appBar: {
    color: 'white',
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarFocus : {
    height: 240,
    zIndex: 200
  },
  appTitleRight: {
    flex: 1,
    textAlign: 'right',
    marginRight: theme.spacing.unit * 3
  },
  appTitleLeft: {
    flex: 1,
    textAlign: 'left',
  },
  hide: {
    display: 'none',
  },
  menuButton: {
    marginLeft: theme.spacing.unit * 1,
    marginRight: theme.spacing.unit * 2,
    color: "white"
  },
  appTitle: {
    color: 'white',
  },
  headerComponent: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  }

})


export default styles


// WEBPACK FOOTER //
// ./src/components/FrameworkStyles.js